import React, { createContext, useContext, useState, ReactNode } from "react";
import { Loading } from "../../components/Loading";

interface OverlayContextType {
  loading: boolean;
  showLoading: () => void;
  hideLoading: () => void;
}

const OverlayContext = createContext<OverlayContextType | undefined>(undefined);

export const useOverlayContext = (): OverlayContextType => {
  const context = useContext(OverlayContext);
  if (!context) {
    throw new Error("useOverlay must be used within an OverlayProvider");
  }
  return context;
};

interface OverlayProviderProps {
  children: ReactNode;
}

export const OverlayProvider: React.FC<OverlayProviderProps> = ({
  children,
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const showLoading = () => setLoading(true);
  const hideLoading = () => setLoading(false);

  return (
    <OverlayContext.Provider value={{ loading, showLoading, hideLoading }}>
      {children}
      {loading && <Loading show={loading} />}
    </OverlayContext.Provider>
  );
};

export const useOverlay = () => {
  const context = useContext(OverlayContext);
    if (!context) {
      throw new Error("useOverlay must be used within a OverlayProvider");
    }
    return context;
};
